var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vcard"},[_c('h1',{staticClass:"v-card__title"},[_vm._v("Vcards")]),_c('technicalSheets'),_c('catalogues'),_c('branches'),_c('div',{staticClass:"vcard__cards"},[_c('createVcardButton'),_c('tableVcard')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }